import React, { useEffect, useState } from "react";
import API from "../api";
import Layout from "../components/Layout";
import { FaEdit, FaTrash } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";

const Products = () => {
    const [products, setProducts] = useState([]);
    const [suppliers, setSuppliers] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [editId, setEditId] = useState(null);

    const [form, setForm] = useState({
        name: "",
        supplier: "",
        category: "",

        quantityStock: "",
        quantityCostPrice: "",
        quantitySellingPrice: "",

        kgStock: "",
        kgCostPrice: "",
        kgSellingPrice: "",
        status: "Stock In"

    });

    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);

    const [showImport, setShowImport] = useState(false);
    const [file, setFile] = useState(null);

    useEffect(() => {
        fetchData();
        fetchDropdowns();
    }, []);

    useEffect(() => {
        setPage(1);
    }, [search, limit]);

    // FETCH PRODUCTS
    const fetchData = async () => {
        try {
            const res = await API.get("/products");
            setProducts(res.data);
        } catch { toast.error("Failed to fetch products"); }
    };

    // FETCH DROPDOWNS
    const fetchDropdowns = async () => {
        try {
            const sup = await API.get("/suppliers");

            setSuppliers(sup.data);
        } catch {
            toast.error("Dropdown load failed");
        }
    };

    const initialForm = {
        name: "",
        supplier: "",
        category: "",

        quantityStock: "",
        quantityCostPrice: "",
        quantitySellingPrice: "",

        kgStock: "",
        kgCostPrice: "",
        kgSellingPrice: "",
        status: "Stock In"
    };

    const resetForm = () => {
        setForm(initialForm);
        setEditId(null);
    };

    // SUBMIT
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editId) {
                await API.put(`/products/${editId}`, form);
                toast.success("Product Updated");
            } else {
                await API.post("/products", form);
                toast.success("Product Added");
            }
            setShowModal(false);
            resetForm();
            await fetchData();
        } catch {
            toast.error("Error saving product");
        }
    };

    // DELETE
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure to delete this product?")) return;

        try {
            await API.delete(`/products/${id}`);
            toast.success("Product deleted");
            fetchData();
        } catch {
            toast.error("Delete failed");
        }
    };

    // EDIT
    const handleEdit = (p) => {
        setForm({
            name: p.name || "",
            supplier: p.supplier?._id || "",
            category: p.category || "",

            quantityStock: p.quantityStock || "",
            quantityCostPrice: p.quantityCostPrice || "",
            quantitySellingPrice: p.quantitySellingPrice || "",

            kgStock: p.kgStock || "",
            kgCostPrice: p.kgCostPrice || "",
            kgSellingPrice: p.kgSellingPrice || "",
            status: p.status || "Stock In"
        });

        setEditId(p._id);
        setShowModal(true);
    };

    // Import Product
    const handleImport = async () => {
        if (!file) {
            toast.error("Please select file");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            await API.post("/products/import", formData);
            toast.success("Products Imported Successfully");
            setShowImport(false);
            fetchData();
        } catch (err) {
            toast.error("Import failed");
        }
    };

    // print
    const handlePrint = () => {
        window.print();
    };

    // FILTER
    const filtered = products.filter(p =>
        p.name?.toLowerCase().includes(search.toLowerCase()) ||
        p.category?.toLowerCase().includes(search.toLowerCase()) ||
        p.supplier?.company?.toLowerCase().includes(search.toLowerCase())
    );

    // PAGINATION
    const perPage = Number(limit);
    const start = (page - 1) * perPage;

    const current = filtered.slice(start, start + perPage);

    const totalPages = Math.ceil(filtered.length / perPage);

    return (
        <Layout>
            <ToastContainer position="top-right" autoClose={3000} />

            <div className="topbar">

                {/* LEFT SIDE */}
                <div className="topbar-left">
                    <h2>Stock Inventory</h2>

                    <button className="import-btn" onClick={() => setShowImport(true)}>
                        Import Product
                    </button>

                    <button className="print-btn" onClick={handlePrint}>
                        Print
                    </button>
                </div>

                {/* RIGHT SIDE */}
                <div className="topbar-right">
                    <button
                        className="add-btn"
                        onClick={() => {
                            resetForm();
                            setShowModal(true);
                        }}
                    >
                        + Add New Product
                    </button>
                </div>

            </div>

            <div className="table-section">

                <div className="table-controls">
                    <div>
                        Show
                        <select value={limit} onChange={(e) => setLimit(e.target.value)}>
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                        </select>
                        entries
                    </div>

                    <input
                        placeholder="Search product..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                <div className="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>S/N</th>
                                <th>Company Name</th>
                                <th>Products</th>
                                <th>Category</th>
                                <th>Qty Stock</th>
                                <th>Qty Sell</th>

                                <th>KG Stock</th>
                                <th>KG Sell</th>
                                <th>Purchase Date</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {current.map((p, i) => (
                                <tr key={p._id}>
                                    <td>{start + i + 1}</td>
                                    <td>{p.supplier?.company}</td>
                                    <td>{p.name}</td>
                                    <td>{p.category}</td>

                                    <td>
                                        {
                                            Number(p.quantityStock) > 0
                                                ? `${p.quantityStock} PCS`
                                                : "--"
                                        }
                                    </td>

                                    {
                                        Number(p.quantitySellingPrice) > 0
                                            ? `₹${p.quantitySellingPrice}`
                                            : "--"
                                    }

                                    <td>
                                        {
                                            Number(p.kgStock) > 0
                                                ? `${p.kgStock} KG`
                                                : "--"
                                        }
                                    </td>

                                    {
                                        Number(p.kgSellingPrice) > 0
                                            ? `₹${p.kgSellingPrice}`
                                            : "--"
                                    }
                                    <td>
                                        {p.createdAt
                                            ? new Date(p.createdAt).toLocaleDateString("en-IN", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric"
                                            })
                                            : "N/A"}
                                    </td>

                                    <td>
                                        <span
                                            className={
                                                p.quantityStock <= 0 &&
                                                    p.kgStock <= 0
                                                    ? "inactive-badge"
                                                    : "active-badge"
                                            }
                                        >
                                            {
                                                p.quantityStock <= 0 &&
                                                    p.kgStock <= 0
                                                    ? "Stock Out"
                                                    : "Stock In"
                                            }
                                        </span>
                                    </td>


                                    <td className="actions">
                                        <button className="edit-btn" onClick={() => handleEdit(p)}>
                                            <FaEdit />
                                        </button>

                                        <button className="delete-btn" onClick={() => handleDelete(p._id)}>
                                            <FaTrash />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button disabled={page === 1} onClick={() => setPage(page - 1)}>
                        Prev
                    </button>

                    {Array.from({ length: totalPages }, (_, i) => (
                        <button
                            key={i}
                            className={page === i + 1 ? "active" : ""}
                            onClick={() => setPage(i + 1)}
                        >
                            {i + 1}
                        </button>
                    ))}

                    <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>
                        Next
                    </button>
                </div>

            </div>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal" style={{ width: '600px' }}>
                        <h3>{editId ? "Edit Product" : "Add Product"}</h3>

                        <form onSubmit={handleSubmit} className="product-form-grid">

                            <input placeholder="Product Name"
                                value={form.name}
                                onChange={e => setForm({ ...form, name: e.target.value })} required />

                            <input
                                placeholder="Category Name"
                                value={form.category}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        category: e.target.value
                                    })
                                }
                            />

                            <h4>Quantity Product</h4>

                            <input
                                type="number"
                                placeholder="Quantity Stock"
                                value={form.quantityStock}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        quantityStock: e.target.value
                                    })
                                }
                            />

                            <input
                                type="number"
                                placeholder="Quantity Cost Price"
                                value={form.quantityCostPrice}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        quantityCostPrice: e.target.value
                                    })
                                }
                            />

                            <input
                                type="number"
                                placeholder="Quantity Selling Price"
                                value={form.quantitySellingPrice}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        quantitySellingPrice: e.target.value
                                    })
                                }
                            />


                            <h4>KG Product</h4>

                            <input
                                type="number"
                                placeholder="KG Stock"
                                value={form.kgStock}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        kgStock: e.target.value
                                    })
                                }
                            />

                            <input
                                type="number"
                                placeholder="KG Cost Price"
                                value={form.kgCostPrice}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        kgCostPrice: e.target.value
                                    })
                                }
                            />

                            <input
                                type="number"
                                placeholder="KG Selling Price"
                                value={form.kgSellingPrice}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        kgSellingPrice: e.target.value
                                    })
                                }
                            />


                            {/* SUPPLIER DROPDOWN */}
                            <select
                                value={form.supplier}
                                onChange={e => setForm({ ...form, supplier: e.target.value })}
                            >
                                <option value="">Select Company</option>
                                {suppliers.map(s => (
                                    <option key={s._id} value={s._id}>{s.company}</option>
                                ))}
                            </select>

                            <div className="modal-actions">
                                <button type="button" onClick={() => { setShowModal(false); resetForm(); }}>
                                    Cancel
                                </button>
                                <button type="submit">Submit</button>
                            </div>

                        </form>
                    </div>
                </div>
            )}

            {showImport && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h3>Import Product</h3>

                        {/* LABEL TEXT */}
                        <p className="import-label">Select CSV File Only</p>

                        {/* FILE INPUT */}
                        <input
                            type="file"
                            accept=".csv,.xlsx"
                            className="file-input"
                            onChange={(e) => setFile(e.target.files[0])}
                        />

                        <div className="modal-actions">
                            <button onClick={() => setShowImport(false)}>
                                Dismiss
                            </button>

                            <button onClick={handleImport}>
                                Import Now
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </Layout>
    );
};

export default Products;